import { IconFilter } from '@tabler/icons-react';
import React from 'react'
import { Dropdown } from 'react-bootstrap'

export const DashboardCardWrapper = ({ headerText, headerSubtext, headerIcon, isDropdown = false, currDropdownItem, setCurrDropdownItem, dropdownItems, children, componentStyles, componentClassname }) => {
    const brandColor = "#7a3a5e";
    const headerIconGradient = "linear-gradient(135deg, #f8e8f0 0%, #efe7ff 55%, #e8f3ff 100%)";

    return (
        <div className={`px-3 pt-3 pb-2 ${componentClassname}`} style={{ boxShadow: "0px 4px 3px 0px rgba(126, 126, 126, 0.1)", border: "1px solid #e3e3e3", borderRadius: "0.625rem", backgroundColor: "#fff", ...componentStyles }}>
            <div className="d-flex justify-content-between align-items-center gap-2">
                <div className="d-flex align-items-center gap-2">
                    {
                        headerIcon &&
                        <div
                            className="p-2 rounded-3 d-flex align-items-center justify-content-center"
                            style={{
                                background: headerIconGradient,
                                border: "1px solid #f1dbe7",
                                boxShadow: "0 2px 8px rgba(122, 58, 94, 0.08)"
                            }}
                        >
                            {headerIcon}
                        </div>
                    }
                    <div className='d-flex-column align-items-start justify-content-center gap-1 '>
                        <span className="d-block mb-0 pb-0" style={{ fontWeight: 500, fontSize: '16px', }}>{headerText}</span>
                        <span className="text-muted d-block" style={{ fontSize: "11px" }}>{headerSubtext}</span>
                    </div>
                </div>
                {
                    isDropdown &&
                    <Dropdown as="div" >
                        <Dropdown.Toggle
                            as="button"
                            className="btn btn-light d-flex align-items-center gap-2 px-2 py-1 text-muted no-arrow"
                            style={{ fontSize: '13px', borderRadius: '8px', fontWeight: '600', border: '1px solid #efefef', textTransform: 'capitalize' }}
                        >
                            <IconFilter size={15} style={{ color: brandColor }} />
                            <span className="text-capitalize">{currDropdownItem}</span>
                            <i className="fa-solid fa-chevron-down align-middle ms-1 d-inline-block"></i>
                        </Dropdown.Toggle>
                        <Dropdown.Menu
                            className="shadow"
                            style={{
                                width: "10rem",
                                padding: "8px 0px",
                                right: "3.4rem",
                            }}
                        >
                            {
                                dropdownItems?.map(c => (
                                    <Dropdown.Item
                                        href="#"
                                        className="d-flex align-items-center"
                                        onClick={() => setCurrDropdownItem(c.value)}
                                    >
                                        {c.label}
                                    </Dropdown.Item>
                                ))
                            }
                        </Dropdown.Menu>
                    </Dropdown>
                }
            </div>
            <hr style={{ height: '0.1rem' }} />
            {children}
        </div>
    )
}